import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../components/_slice/index";

export const store = configureStore({
  reducer: rootReducer,
});
